<template>
	<div class="userCenter">
		<div class="userCenter_top">
			<div class="userCenter_top_left">
				<div class="userCenter_top_left_pic">
					<img v-if="user_info.u_picture" :src="user_info.u_picture" alt="">
					<img v-else src="../../assets/xiangning/u_picture.png" alt="">


				</div>
				<div class="userCenter_top_left_content">
					<div class="userCenter_top_left_content_title">
						{{ user_info.u_name }},欢迎您！
					</div>
					<div class="userCenter_top_left_content_bottom">
						{{ user_info.cy_zz }}
					</div>
				</div>
			</div>
			<div class="userCenter_top_right">
				<div class="userCenter_top_right_item">
					<div class="userCenter_top_right_item_top">
						我的收藏
					</div>
					<div class="userCenter_top_right_item_bottom">
						{{ infoUpData.col_count }}
					</div>
				</div>
				<div class="userCenter_top_right_item">
					<div class="userCenter_top_right_item_top">
						我的下载
					</div>
					<div class="userCenter_top_right_item_bottom">
						{{ infoUpData.down_count }}
					</div>
				</div>
				<div class="userCenter_top_right_item">
					<div class="userCenter_top_right_item_top">
						三会一课
					</div>
					<div class="userCenter_top_right_item_bottom">
						{{ infoUpData.activity_count }}
					</div>
				</div>
				<div class="userCenter_top_right_item">
					<div class="userCenter_top_right_item_top">
						集体培训
					</div>
					<div class="userCenter_top_right_item_bottom">

						{{ infoUpData.train1_count }}
					</div>
				</div>
				<div class="userCenter_top_right_item" v-if="ruleForm2.flag == 4">
					<div class="userCenter_top_right_item_top">
						党员培训
					</div>
					<div class="userCenter_top_right_item_bottom">
						{{ infoUpData.train2_count }}
					</div>
				</div>

				<div class="userCenter_top_right_item">
					<div class="userCenter_top_right_item_top">
						学习课时
					</div>
					<div class="userCenter_top_right_item_bottom">
						{{ infoUpData.hours_count }}
					</div>
				</div>
				<div v-if="ruleForm2.flag == 4" class="userCenter_top_right_item" style="borderRight: 0;">
					<div class="userCenter_top_right_item_top">
						在线考试
					</div>
					<div class="userCenter_top_right_item_bottom">
						{{ infoUpData.online_count }}
					</div>
				</div>


			</div>
		</div>
		<div class="userCenter_bottom">
			<div class="userCenter_bottom_left">
				<div class="userCenter_bottom_left_title">
					我的学习
				</div>
				<div @click="ChangeSelectTitle(2)" :style="{
						backgroundColor: selectTitle == 2 ? '#FDEFE9' : ''
					}" style="margin-top: 25px;" class="userCenter_bottom_left_title_item">
					<img src="../../assets/xiangning/userCenter/userCenter_icon.png" alt="">浏览记录
				</div>
				<div @click="ChangeSelectTitle(1)" :style="{
						backgroundColor: selectTitle == 1 ? '#FDEFE9' : ''
					}" class="userCenter_bottom_left_title_item">
					<img src="../../assets/xiangning/userCenter/userCenter_icon.png" alt="">我的收藏
				</div>
				<div @click="ChangeSelectTitle(3)" :style="{
						backgroundColor: selectTitle == 3 ? '#FDEFE9' : ''
					}" style="margin-bottom: 25px;" class="userCenter_bottom_left_title_item">
					<img src="../../assets/xiangning/userCenter/userCenter_icon.png" alt="">我的下载
				</div>
				<div class="userCenter_bottom_left_title">
					组织生活
				</div>
				<div @click="ChangeSelectTitle(4)" :style="{
						backgroundColor: selectTitle == 4 ? '#FDEFE9' : ''
					}" style="margin-top: 25px;" class="userCenter_bottom_left_title_item">
					<img src="../../assets/xiangning/userCenter/active.png" alt="">三会一课
				</div>
				<div v-if="$store.state.user.userinfo2.flag == 4" @click="ChangeSelectTitle(5)" :style="{
						backgroundColor: selectTitle == 5 ? '#FDEFE9' : ''
					}" class="userCenter_bottom_left_title_item">
					<img src="../../assets/xiangning/userCenter/document.png" alt="">在线考试
				</div>
				<!-- -->
				<!-- <div v-if="$store.state.user.userinfo2.flag!=4"    @click="ChangeSelectTitle(10)" :style="{
					backgroundColor:selectTitle==10?'#FDEFE9':''
				}"    class="userCenter_bottom_left_title_item">
					 <img src="../../assets/xiangning/userCenter/work.png" alt="">工作任务
				</div> -->
				<div @click="ChangeSelectTitle(6)" :style="{
						backgroundColor: selectTitle == 6 ? '#FDEFE9' : ''
					}" style="margin-bottom: 25px;" class="userCenter_bottom_left_title_item">
					<img src="../../assets/xiangning/userCenter/work.png" alt="">培训任务
				</div>

				<div class="userCenter_bottom_left_title">
					账户设置
				</div>
				<div v-if="$store.state.user.userinfo2.flag == 4" @click="ChangeSelectTitle(7)" :style="{
						backgroundColor: selectTitle == 7 ? '#FDEFE9' : ''
					}" style="margin-top: 25px;" class="userCenter_bottom_left_title_item">
					<img src="../../assets/xiangning/userCenter/user check.png" alt="">基本信息
				</div>
				<div @click="ChangeSelectTitle(8)" :style="{
						backgroundColor: selectTitle == 8 ? '#FDEFE9' : ''
					}" class="userCenter_bottom_left_title_item">
					<img src="../../assets/xiangning/userCenter/password.png" alt="">修改密码
				</div>
				<div class="bottom_message">
					说明:浏览记录只保存近一个月的数据
				</div>

			</div>
			<div class="userCenter_bottom_right">
				<!--浏览记录-->
				<div class="dataList_item" v-if="selectTitle <= 3" @click="geDjxxResouce(item)" v-for="item in dataList"
					:key="item.id">
					<div class="dataList_item_top_img"><img :src="item.sz_img" alt="" style="width: 100%;height: 100%;">
					</div>
					<div class="dataList_item_bottom">
						<!-- 上方标题 -->
						<div class="dataList_item_bottom_top_title">{{ item.title }}
						</div>
						<div class="dataList_item_bottom_bottom_time">{{ item.addtime }}
						</div>
					</div>
				</div>
				<div v-if="dataList.length == 0" style="margin: 100px auto;">
					<img src="../../assets/djnodata.png" alt="">
				</div>
				<!--三会一课 -->
				<div class="dataList_item_active" v-if="selectTitle == 4" @click="goZzshDetail(item)"
					v-for="item in dataList">
					<!-- 课程状态未开始-->
					<div class="notStart" v-if="false">
						未开始
					</div>
					<!-- 课程状态已完成-->
					<div class="haveFilsh" v-if="false">
						已完成
					</div>
					<div class="dataList_item_top_img">
						<img src="../../assets/xiangning/zzsh/zzsh_list.png" alt="">
					</div>
					<div class="dataList_item_bottom">
						<!-- 上方标题 -->
						<div class="dataList_item_bottom_top_title">{{ item.title }}</div>
						<!-- 所属组织 -->
						<div class="dataList_item_bottom_center">
							<span>{{ item.type }}</span>
							<span>{{ item.h_stime }}</span>
						</div>
						<!-- 地点 -->
						<div class="dataList_item_bottom_address">
							{{ item.address }}
						</div>
					</div>
				</div>
				<!-- 在线考试 -->
				<div class="myWork" v-if="selectTitle == 5">
					<el-table header-row-class-name="tableHeader" :data="dataList" style="width: 100%">
						<el-table-column align="center" prop="id" label="序号" width="80">
							<template slot-scope="scope">
								{{ scope.$index + 1 }}
							</template>
						</el-table-column>
						<el-table-column prop="title" label="考试名称" width="580">
						</el-table-column>
						<el-table-column align="center" prop="time" width="220px" label="考试时间">
							<template slot-scope="scope">
								{{ scope.row.s_time }}至{{ scope.row.e_time }}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="" label="操作">
							<template slot-scope="scope">
								<!-- 发布者 -->
								<div>
									<el-button v-if="scope.row.complete == 0" size="mini"
										@click="goOnLineExam(scope.row)" style="margin-left: 0;margin-right: 5px;"
										type="text">开始考试</el-button>
									<el-button v-else size="mini" @click="goOnLineExamDetail(scope.row)"
										style="margin-left: 0;margin-right: 5px;" type="text">查看详情</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 专题培训 -->
				<div v-if="selectTitle == 6" class="dataList_item_ztpx" v-for="item in dataList" :key="item.id"
					@click="goDjxxDetail(item.id)">
					<div class="notStart" v-if="false">
						未开始
					</div>
					<!-- 课程状态已完成-->
					<div class="haveFilsh" v-if="false">
						已完成
					</div>
					<div class="dataList_item_top_img">
						<img style="width: 100%;height: 100%;" :src="item.sz_img" alt="">
					</div>
					<div class="dataList_item_bottom">
						<!-- 上方标题 -->
						<div class="dataList_item_bottom_top_title">{{ item.title }}</div>
						<!-- 下方课程信息 -->
						<div class="dataList_item_bottom_botom">
							<div class="dataList_item_bottom_botom_item">
								<div class="dataList_item_bottom_botom_item_icon">
									<img src="../../assets/xiangning/djxx/icon_1.png" alt="">
								</div>
								<div class="dataList_item_bottom_botom_item_content">
									共{{ item.count }}课
								</div>
							</div>
							<div class="dataList_item_bottom_botom_item">
								<div class="dataList_item_bottom_botom_item_icon">
									<img src="../../assets/xiangning/djxx/icon_3.png" alt="">
								</div>
								<div class="dataList_item_bottom_botom_item_content">
									{{ item.hours }}课时
								</div>
							</div>
							<div class="dataList_item_bottom_botom_item">
								<div class="dataList_item_bottom_botom_item_icon">
									<img src="../../assets/xiangning/djxx/icon_2.png" alt="">
								</div>
								<div class="dataList_item_bottom_botom_item_content">
									{{ item.xn_nums }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 基本信息 -->
				<div v-if="selectTitle == 7" class="uerInfo">
					<div style="width: 600px;">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
							class="demo-ruleForm">
							<el-form-item label="党员姓名：" prop="u_name">
								<el-input placeholder="请输入党员姓名" v-model="ruleForm.u_name"></el-input>
							</el-form-item>
							<el-form-item label="联系方式：" prop="u_phone">
								<el-input placeholder="请输入正确的手机号用于登录平台" v-model="ruleForm.u_phone"></el-input>
							</el-form-item>
							<el-form-item label="入党时间：" prop="attendtime">
								<el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="请选择对应的日期"
									v-model="ruleForm.attendtime" style="width: 100%;">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="党员性别：" prop="sex">
								<el-radio-group text-color="#C41515" v-model="ruleForm.sex">
									<el-radio label="男"></el-radio>
									<el-radio label="女"></el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="党员学历：" prop="education">
								<el-radio-group v-model="ruleForm.education">
									<el-radio label='1'>高中及以下</el-radio>
									<el-radio label='2'>大专</el-radio>
									<el-radio label='3'>本科</el-radio>
									<el-radio label='4'>硕士及以上</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="出生年月：" prop="age">
								<el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="请选择对应的日期"
									v-model="ruleForm.age" style="width: 100%;">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="党员民族：" prop="nation">
								<el-select v-model="ruleForm.nation" placeholder="请选择民族">
									<el-option v-for="item in nationList" :label="item.option"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="通讯地址：" prop="postal_address">
								<el-input placeholder="请输入通讯地址" type="textarea"
									v-model="ruleForm.postal_address"></el-input>
							</el-form-item>
							<el-form-item label="个人照片：" prop="u_picture">
								<el-upload :data="{
						// uid:$store.state.id,
						uid: 1,
						flag: Flag, dir: 'p5/qxzj.gxsentu.net/' + timeNow
					}" :action="uploadImg" :on-success="uploadSuccess" :show-file-list="false" :before-upload="beforeAvatarUpload">
									<img v-if="ruleForm.u_picture" :src="ruleForm.u_picture" class="avatar">
									<el-button v-if="ruleForm.u_picture" type="danger"
										style="background-color: #C41515;border: #C41515;">
										重新上传</el-button>
									<el-button v-else type="danger" style="background-color: #C41515;border: #C41515;">
										浏览</el-button>
									<span slot="tip" style="margin-left: 14px;color: #919191;font-size: 14px;"
										class="el-upload__tip">支持png、jpg格式,大小不超过2MB</span>
								</el-upload>
							</el-form-item>
							<el-form-item style="display: flex;justify-content: center;">
								<el-button style="background-color: #C41515;border: #C41515; margin-right: 40px;"
									type="primary" @click="submitForm('ruleForm')">保存</el-button>
								<el-button @click="resetForm('ruleForm')">取消</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<!-- 修改密码 -->
				<div v-if="selectTitle == 8" class="uerInfo">
					<div style="width: 600px;">
						<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm" label-width="100px"
							class="demo-ruleForm">
							<el-form-item label="原有密码:" prop="oldPwd">
								<el-input show-password placeholder="请输入初始密码" v-model="ruleForm2.oldPwd"></el-input>
							</el-form-item>
							<el-form-item label="新设密码:" prop="newPwd">
								<el-input show-password placeholder="请输入新设密码" v-model="ruleForm2.newPwd"></el-input>
							</el-form-item>
							<el-form-item label="确认密码:" prop="repPwd">
								<el-input show-password placeholder="请再次输入密码" v-model="ruleForm2.repPwd"></el-input>
							</el-form-item>
							<el-form-item style="display: flex;justify-content: center;">
								<el-button style="background-color: #C41515;border: #C41515; margin-right: 40px;"
									type="primary" @click="submitForm2('ruleForm')">保存</el-button>
								<el-button @click="resetForm2('ruleForm')">取消</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<!-- 工作任务 -->
				<div class="myWork" v-if="selectTitle == 10">
					<el-table header-row-class-name="tableHeader" :data="dataList" style="width: 100%">
						<el-table-column align="center" prop="id" label="任务序号" width="80">
							<template slot-scope="scope">
								{{ scope.$index + 1 }}
							</template>
						</el-table-column>
						<el-table-column prop="title" label="任务名称" width="500px">
						</el-table-column>
						<el-table-column align="center" prop="e_time" width="200px" label="截止时间">
						</el-table-column>
						<el-table-column align="center" prop="" label="操作">
							<template slot-scope="scope">
								<!-- 发布者 -->
								<div>
									<el-button size="mini" @click="goWorkDetail(scope.row)"
										style="margin-left: 0;margin-right: 5px;" type="text">查看详情</el-button>
								</div>

							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 工作任务详情 -->
				<div class="myWork" v-if="selectTitle == 11">
					<div class="myWork_top">任务名称：<span style="font-weight: 800;">{{ workInfo.title }}</span></div>
					<div class="myWork_center">
						<div class="myWork_center_item">承办单位：<span style="font-weight: 800;"></span></div>
						<div class="myWork_center_item">负责人：<span style="font-weight: 800;">{{ workInfo.head_name
								}}</span></div>
						<div class="myWork_center_item">截止时间：<span style="font-weight: 800;">{{ workInfo.e_time
								}}</span></div>
					</div>
					<div class="myWork_content">
						<div class="myWork_content_let">
							任务内容：
						</div>
						<div class="myWork_content_right" v-html="workInfo.content">

						</div>
					</div>
					<div class="myWork_attachment" v-if="workInfo.files.length > 0">
						<div class="myWork_attachment_left">
							任务附件：
						</div>
						<div class="myWork_attachment_right">
							<div v-for="item in workInfo.files" class="myWork_attachment_right_item"
								style="color:#1C76FD;">
								<img src="../../assets/xiangning/userCenter/file_idon.png" alt="">
								&nbsp; {{ item.name }}
							</div>

						</div>
					</div>
					<!-- 任务汇报 -->
					<div class="myWork_attachment">
						<div @click="log" class="myWork_attachment_left">
							任务汇报：
						</div>
						<div class="myWork_attachment_right">
							<quill-editor :disabled="false" :options="$VueQuillEditor" ref="myTextEditor"
								v-model="updateWork.content" style="width: 500px; " class="sz_nr"></quill-editor>
						</div>
					</div>
					<!-- 任务汇报 -->
					<div class="myWork_attachment">
						<div @click="log" class="myWork_attachment_left">
							汇报附件：
						</div>
						<div class="myWork_attachment_right">
							<el-upload :data="{
						// uid:$store.state.id,
						flag: Flag, dir: 'p5/qxzj.gxsentu.net/' + timeNow
					}" :action="uploadImg" :on-success="uploadSuccess2" :show-file-list="false" :before-upload="beforeAvatarUpload2">
								<div v-if="updateWork.files.length > 0" v-for="item in updateWork.files"
									class="myWork_attachment_right_item" style="color:#1C76FD;margin-bottom: 10px;">
									<img src="../../assets/xiangning/userCenter/file_idon.png" alt="">
									&nbsp; {{ item.name }}
								</div>
								<el-button v-if="updateWork.files.length > 0" type="danger"
									style="background-color: #C41515;border: #C41515;">
									重新上传</el-button>
								<el-button v-else type="danger" style="background-color: #C41515;border: #C41515;">
									浏览</el-button>
								<span slot="tip" style="margin-left: 14px;color: #919191;font-size: 14px;"
									class="el-upload__tip">说明：支持上传文件PDF、word和excel，大小不得超过10M</span>
							</el-upload>
						</div>
					</div>
					<div class="myWork_bottom">
						<el-button style="background-color: #C41515;border: #C41515; margin-right: 40px;" type="primary"
							@click="submitWork('ruleForm')">保存</el-button>
						<el-button @click="resectWorkUpdate">取消</el-button>
					</div>
				</div>

			</div>

		</div>
		<Page v-if="total > 0" :total="total" :per_page="per_page" :pageSize="[20]"
			@handleCurrentChange="handleCurrentChange">
		</Page>
	</div>
</template>
<script>
import { news, user } from '@/axios';
import Page from '@/components/page.vue'
export default {
	data() {
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm2.newPwd) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			per_page: 1,
			total: 0,
			// 用户信息
			user_info: {},
			// 顶部数据
			infoUpData: {},
			hcontent: '',
			Flag: 1,
			timeNow: '',
			uploadImg: 'http://xlgl.gxsentu.net/?c=d_collect&m=uploadFile',
			selectTitle: 2,
			flag: 1,
			ruleForm: {
				id: '',
				u_name: '',
				u_phone: '',
				attendtime: '',
				sex: '男',
				education: '1',
				age: '',
				nation: '',
				postal_address: '',
				u_picture: '',
			},
			ruleForm2: {
				id: this.$store.state.user.userinfo2.id,
				flag: this.$store.state.user.userinfo2.flag,
				oldPwd: '',
				newPwd: '',
				repPwd: '',
				// 工作任务信息

			},
			rules2: {
				oldPwd: [
					{ required: true, message: '请输入初始密码', trigger: 'blur' },
					// { min: 8, max: 20, message: '长度在 8 到 20 个字符', trigger: 'blur' }
				],
				newPwd: [
					{ required: true, message: '请输入新密码', trigger: 'blur' },
					// { min: 8, max: 20, message: '长度在 8 到 20 个字符', trigger: 'blur' }
				],
				repPwd: [
					{ required: true, message: '请再次输入密码', trigger: 'blur' },
					// { min: 8, max: 20, message: '长度在 8 到 20 个字符', trigger: 'blur' },
					{ validator: validatePass2, trigger: 'blur' }
				],
			},
			rules: {
				u_name: [
					{ required: true, message: '请输入党员姓名', trigger: 'blur' },
				],
				u_phone: [
					{ required: true, message: '手机号不能为空', trigger: 'blur' },
					{
						required: true,
						pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
						message: '请输入正确的手机号码',
						trigger: 'blur',
					},
				],
			},
			// 民族
			nationList: [],

			tableData: [


			],
			// 三会一课列表
			shyklist: [],
			//学习参数列表
			getStudydata: {
				// uid:14668,
				// flag:4,
				uid: this.$store.state.user.userinfo2.id,
				flag: this.$store.state.user.userinfo2.flag,
				collar: 2,
				page: 1
			},
			dataList: [],
			workInfo: {},
			// 工作任务提交的参数
			updateWork: {
				id: '',
				uid: this.$store.state.user.userinfo2.id,
				content: '',
				files: []
			}
		}
	},
	components: { Page },
	methods: {
		// 组织生活详情
		goZzshDetail(data) {
			this.$router.push({
				path: '/zzshDetail',
				query: {
					id: data.id,
					flag: data.hyflag
				}
			})
		},
		// 跳转至专题培训详情
		goDjxxDetail(id) {

			this.$router.push({
				path: "/ztpxDetail",
				query: {
					tid: id
				}
			})
		},
		goOnLineExam(data) {
			this.$router.push({
				path: '/onLineExam',
				query: {
					tid: data.tid,
					aid: data.id
				}
			})
		},
		goOnLineExamDetail(data) {
			this.$router.push({
				path: '/onLineExamDetail',
				query: {
					tid: data.tid,
					aid: data.id
				}
			})
		},
		geDjxxResouce(data) {
			let that = this
			if (data.flag == 1) {
				this.$router.push({
					path: '/yxzlResouce',
					query: {
						id: data.rid,
						flag: data.flag,
						type: 'userCenter'
					}
				})
			} else {
				if (data.bs_id == 4) {
					this.$router.push({
						path: '/audioDetail',
						query: {
							id: data.rid,
							flag: data.flag,
							type: 'djxx'


						}
					})
				} else {
					this.$router.push({
						path: '/djxxResouce',
						query: {
							id: data.rid,
							flag: data.flag,
							type: 'userCenter'
						}
					})
				}

			}
		},
		handleCurrentChange(val) {
			let that = this
			that.getStudydata.page = val
			if (that.selectTitle <= 3) {
				that.getStudy()
			}
			if (that.selectTitle == 4) {
				// 三会一课
				that.getShykList()
			}
			if (that.selectTitle == 5) {
				// 在线考试
				that.ExamList()
			}
			if (that.selectTitle == 6) {
				that.getPxList()
			}
			if (that.selectTitle == 7) {
				// 用户信息
				that.getUserInfo()
			}
			if (that.selectTitle == 10) {
				// 用户信息
				that.getWorkList()


			}

		},
		goWorkDetail(data) {
			let that = this
			this.selectTitle = 11
			this.updateWork.id = data.id
			// 获取工作任务详情
			user.updateWork({ id: data.id }).then(res => {

				that.workInfo = res.data
			})
		},
		log() {

		},
		// 截取字符串中
		getCaption(obj) {
			const index = obj.lastIndexOf("p5")
			const res = obj.substring(index, obj.length)
			return res
		},
		// 文件上传删除
		delFile(index) {
			var that = this;

			special.delfile({
				fileName: that.getCaption(index),
				token: sessionStorage.getItem("token")
			})
		},
		// 三会一课列表
		getShykList() {
			let that = this
			user.infoShykList(that.getStudydata).then((res) => {
				if (res.code == 200) {
					that.total = res.data.count
					that.dataList = res.data.pagedata
				}
			})
		},
		// 在线考试列表
		ExamList() {
			let that = this
			user.ExamList(that.getStudydata).then((res) => {
				if (res.code == 200) {
					that.total = res.data.count
					that.dataList = res.data.pagedata
				}
			})
		},
		//培训任务列表
		getPxList() {
			let that = this
			user.tranList(that.getStudydata).then((res) => {
				if (res.code == 200) {
					that.total = res.data.count
					that.dataList = res.data.pagedata
				}
			})
		},
		// 工作任务列表
		getWorkList() {
			let that = this
			user.WorkList(that.getStudydata).then((res) => {
				if (res.code == 200) {
					that.total = res.data.count
					that.dataList = res.data.pagedata
				}
			})
			// user.WorkList({uid:893,flag:5}).then((res)=>{
			// 		if (res.code==200) {
			// 			that.total=res.data.count
			// 		    that.dataList=res.data.pagedata
			// 		}
			// 	})

		},
		ChangeSelectTitle(val) {
			let that = this
			this.selectTitle = val
			if (val <= 3) {
				that.getStudydata.collar = val
				that.getStudydata.page = 1
				that.getStudy()
			}
			if (val == 4) {
				// 三会一课
				that.getShykList()
			}
			if (val == 5) {
				// 在线考试
				that.ExamList()
			}
			if (val == 6) {
				that.getPxList()
			}
			if (val == 7) {
				// 用户信息
				that.getUserInfo()
			}
			if (val == 10) {
				// 用户信息
				that.getWorkList()
			}
		},
		submitForm(formName) {
			let that = this
			this.$refs[formName].validate((valid) => {
				if (valid) {

					// 向服务器发起请求更新信息
					user.updateUserinfo(that.ruleForm).then((res) => {
						if (res.code == 200) {
							this.$message({
								message: '保存成功',
								type: 'warning'
							});
						}
					})

				} else {

					return false;
				}
			});
		},
		// 获取用户信息
		getUserInfo() {
			let that = this
			// 向服务器发起请求获取用户信息
			user.userinfo({ id: this.$store.state.user.userinfo2.id }).then((res) => {
				if (res.code == 200) {
					that.ruleForm.u_name = res.data.u_name
					that.ruleForm.u_phone = res.data.u_phone
					that.ruleForm.attendtime = res.data.attendtime
					that.ruleForm.sex = res.data.sex
					that.ruleForm.age = res.data.age
					that.ruleForm.nation = res.data.nation
					that.ruleForm.education = res.data.education == '高中及以下' ? '1' : (res.data.education == '大专' ? '2' : (res.data.education == '本科' ? '3'
						: '4'))

					that.ruleForm.postal_address = res.data.postal_address
					that.ruleForm.u_picture = res.data.u_picture
					that.ruleForm.id = res.data.id
				}
			})
		},
		// 修改密码提交
		submitForm2(formName) {
			let that = this
			this.$refs[formName].validate((valid) => {
				if (valid) {

					// 向服务器发起请求更新信息
					user.updatePwd(that.ruleForm2).then((res) => {
						if (res.code == 200) {
							this.$message({
								message: '修改密码成功',
								type: 'success'
							});
						}
					})

				} else {

					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		// 照片上传限制
		beforeAvatarUpload(file) {

			const isPNG = file.type === 'image/png'
				|| file.type === 'image/jpg'
				|| file.type === 'image/jpeg';
			const isLt2M = file.size / 1024 / 1024 < 10;
			if (!isPNG) {
				this.$message({
					message: '请上传正确的文件格式',
					type: 'warning'
				});
				return false;
			} else if (!isLt2M) {
				this.$message({
					message: '上传的肉片大小不超过10MB!',
					type: 'warning'
				});
				return false;
			}
		},
		// 汇报附件上传限制
		beforeAvatarUpload2(file) {

			const isPNG = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
				|| file.type === 'application/pdf'
				|| file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				|| file.type === 'application/msword"';
			const isLt2M = file.size / 1024 / 1024 < 10;
			if (!isPNG) {
				this.$message({
					message: '请上传正确的文件格式',
					type: 'warning'
				});
				return false;
			} else if (!isLt2M) {
				this.$message({
					message: '上传的肉片大小不超过10MB!',
					type: 'warning'
				});
				return false;
			}
		},
		// 照片上传成功
		uploadSuccess(res, file, fileList) {

			let that = this
			if (res.code == 200) {
				//   先删除原有的图片路径
				if (that.ruleForm.u_picture != '') {

					news.delfile({
						fileName: that.getCaption(that.ruleForm.u_picture),
						token: 'MTY5MTU2MjU0NJenp7KWyHZ1'
					})
				}
				that.ruleForm.u_picture = res.data
			} else {
				this.$message({
					message: '上传失败',
					type: 'warning'
				});
			}
		},
		// 汇报附件上传成功
		uploadSuccess2(res, file, fileList) {

			let that = this
			if (res.code == 200) {


				that.updateWork.files = []
				let obj = {}
				obj.name = file.name
				obj.url = res.data
				if (file.raw.type == 'application/pdf') {
					obj.bsid = 8
				} else {
					obj.bsid = 6
				}
				that.updateWork.files.push(obj)

			} else {
				this.$message({
					message: '上传失败',
					type: 'warning'
				});
			}
		},
		// 任务汇报提交
		submitWork() {
			let that = this
			user.updateWork2(that.updateWork).then(res => {
				if (res.code == 200) {
					this.$message({
						message: '工作任务提交成功',
						type: 'success'
					});
					that.selectTitle = 10
					that.updateWork.content = ''
					that.updateWork.files = []
				}
			})
		},
		resectWorkUpdate() {
			let that = this
			that.selectTitle = 10
			that.updateWork.content = ''
			that.updateWork.files = []
		},
		timestampToTime(times) {
			let time = times[1]
			let mdy = times[0]
			mdy = mdy.split('/')
			let month = parseInt(mdy[0]);
			let day = parseInt(mdy[1]);
			let year = parseInt(mdy[2])
			return year + '-' + month + '-' + day
		},
		// 获取民族列表
		getNationList() {
			let that = this
			user.getNationList().then((res) => {
				if (res.code == 200) {
					that.nationList = res.data
				}
			})
		},
		// 个人中心
		infoIndex() {
			let that = this
			user.infoIndex({ id: that.$store.state.user.userinfo2.id, flag: that.$store.state.user.userinfo2.flag }).then((res) => {
				if (res.code == 200) {

					that.user_info = res.data
				}
			})
		},
		// 个人中心顶部数据
		getInfoUpData() {
			let that = this
			user.infoUpData({ id: that.$store.state.user.userinfo2.id, flag: that.$store.state.user.userinfo2.flag }).then((res) => {
				if (res.code == 200) {

					that.infoUpData = res.data
				}
			})
		},
		//  个人中心学习数据
		getStudy() {
			let that = this
			user.collectList(that.getStudydata).then(res => {
				if (res.code == 200) {

					that.total = res.data.count
					that.dataList = res.data.pagedata
				}
			})
		}
	},
	mounted() {
		let time = new Date()
		this.timeNow = this.timestampToTime(time.toLocaleString('en-US', { hour12: false }).split(" "))
		let that = this
		// that.getDataList()
		// 
		// 获取民族列表
		this.getNationList()
		// 个人中心
		this.infoIndex()
		// 个人中心顶部数据
		this.getInfoUpData()
		// 个人中心学习数据
		this.getStudy()
		// 获取用户信息
		this.getUserInfo()
		console.log(user_info.u_picture);
	},
	created() {

	}
}
</script>

<style lang="scss">
.tableHeader {
	font-family: PingFangSC-Medium;
	font-size: 14px;
	font-weight: normal;
	line-height: 24px;

	align-items: center;
	letter-spacing: 0px;

	color: #000000;
}

/* 选中后的字体颜色 */
.el-radio__input.is-checked+.el-radio__label {
	color: #C41515 !important;
}

/* 选中后小圆点的颜色 */
.el-radio__input.is-checked .el-radio__inner {
	background: #C41515 !important;
	border-color: #C41515 !important;
}

.avatar {
	width: 220px;
	display: inline-block;
	height: 160px;
	vertical-align: bottom;
	margin-right: 16px;
}

@import '@/common/index.scss';

.userCenter {
	width: 1200px;
	margin: 0 auto;

	.userCenter_top {
		margin-top: 30px;
		width: 100%;
		height: 120px;
		display: flex;
		justify-content: space-between;

		.userCenter_top_left {
			display: flex;
			justify-content: space-between;
			overflow: hidden;
			box-sizing: border-box;
			padding: 20px;
			width: 468px;
			height: 100%;
			background-image: url(../../assets/xiangning/userCenter/userCenter.png);
			background-size: 100% 100%;

			.userCenter_top_left_pic {
				width: 80px;
				height: 80px;

				box-sizing: border-box;
				border: 2px solid #FFFFFF;
				border-radius: 50%;
				overflow: hidden;

				img {
					width: 100%;
					height: 100%;

				}
			}

			.userCenter_top_left_content {
				width: 328px;
				height: 100%;
				// background-color: pink;
				box-sizing: border-box;
				padding: 12px 0;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.userCenter_top_left_content_title {
					width: 100%;
					height: 25px;
					font-family: PingFang SC;
					font-size: 18px;
					font-weight: 600;
					letter-spacing: 0px;
					color: #FFFFFF;
					line-height: 25px;

				}

				.userCenter_top_left_content_bottom {
					width: 100%;
					height: 20px;
					font-family: PingFang SC;
					font-size: 14px;
					font-weight: normal;
					letter-spacing: 0px;

					color: #FFFFFF;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					line-height: 20px;
				}
			}
		}

		.userCenter_top_right {
			width: 712px;
			height: 100%;
			box-sizing: border-box;
			/* 线 */
			border: 1px solid #ECEEF4;
			border-radius: 4px;
			box-sizing: border-box;
			padding: 30px 20px;
			display: flex;
			justify-content: center;

			.userCenter_top_right_item {
				width: 96px;
				border-right: 1px solid #DCDFE6;
				height: 100%;

				.userCenter_top_right_item_top {
					width: 100%;
					height: 30px;
					font-family: PingFang SC;
					font-size: 14px;
					font-weight: normal;
					text-align: center;
					letter-spacing: 0px;
					color: #000000;
				}

				.userCenter_top_right_item_bottom {
					width: 100%;
					height: 30px;
					line-height: 30px;
					font-family: PingFang SC;
					font-size: 20px;
					font-weight: 600;
					text-align: center;
					letter-spacing: 0px;

					color: #EE632B;
				}
			}
		}
	}

	.userCenter_bottom {
		margin-top: 20px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-bottom: 30px;

		.userCenter_bottom_left {
			width: 224px;
			height: 600px;
			border: 1px solid #ECEEF4;
			box-sizing: border-box;
			padding: 20px 10px;

			.userCenter_bottom_left_title {
				line-height: 22px;
				width: 100%;
				height: 22px;
				box-sizing: border-box;
				border-left: 4px solid #EE632B;
				font-family: PingFang SC;
				font-size: 16px;
				font-weight: 500;
				letter-spacing: 0.1em;
				color: #000000;
				padding-left: 10px;
			}

			.userCenter_bottom_left_title_item {
				width: 100%;
				height: 40px;
				text-align: center;
				font-family: PingFang SC;
				font-size: 14px;
				font-weight: normal;
				text-align: center;
				letter-spacing: 0px;
				color: #000000;
				line-height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.userCenter_bottom_left_title_item img {
				margin-right: 10px;
				width: 14px;
				height: 14px;
			}

			.userCenter_bottom_left_title_item:hover {
				background-color: #FDEFE9;
			}

			.bottom_message {
				margin-top: 25px;
				font-family: PingFang SC;
				font-size: 8px;
				font-weight: normal;
				letter-spacing: 0px;
				color: #999999;
			}
		}

		.userCenter_bottom_right {
			width: 960px;
			height: 600;
			// background-color: pink;
			display: flex;
			flex-wrap: wrap;
			align-content: start;

			.dataList_item {
				box-sizing: border-box;
				width: 224px;
				height: 187px;
				margin-bottom: 20px;
				margin-right: 20px;
				/* 修改圆角 */
				border-radius: 4px;
				overflow: hidden;
				position: relative;

				.notStart {
					height: 24px;
					width: 62px;
					color: #fff;
					position: absolute;
					left: 0px;
					top: 10px;
					// background-image: url(../image/zzsh/notstart.png);
					background-image: url(../../assets/xiangning/zzsh/notstart.png);
					font-family: 思源黑体;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;
					color: #FFFFFF;
					line-height: 24px;
					box-sizing: border-box;
					padding-left: 7px;
				}

				.haveFilsh {
					height: 24px;
					width: 62px;
					color: #fff;
					position: absolute;
					left: 0px;
					top: 10px;
					background-image: url(../../assets/xiangning/zzsh/haveFinlsh.png);
					font-family: 思源黑体;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;
					color: #FFFFFF;
					line-height: 24px;
					box-sizing: border-box;
					padding-left: 7px;
				}

			}

			.dataList_item:nth-child(4n) {
				margin-right: 0;
			}

			.dataList_item_top_img {
				height: 126px;
				width: 224px;
				/* 修改圆角 */
				border-radius: 4px 4px 0 0;
				overflow: hidden;
			}

			.dataList_item_bottom {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				box-sizing: border-box;
				width: 100%;
				height: 60px;
				border: 1px solid #ECEEF4;
				padding: 10px;
				/* 修改圆角 */
				border-radius: 0 0 4px 4px;
				overflow: hidden;
			}

			.dataList_item_bottom_top_title {
				width: 100%;
				height: 20px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-family: PingFangSC-Medium;
				font-size: 14px;
				font-weight: 800;
				line-height: 20px;
				color: #000000;

			}

			.dataList_item_bottom_top_title:hover {
				color: #C9010A;
			}

			.dataList_item_bottom_bottom_time {
				font-family: PingFang SC;
				font-size: 12px;
				font-weight: normal;
				text-align: left;
				letter-spacing: 0em;
				color: #999999;
				margin-top: 4px;
			}

			// 三会一课
			.dataList_item_active {
				box-sizing: border-box;
				width: 224px;
				height: 208px;
				margin-bottom: 20px;
				margin-right: 20px;
				/* 修改圆角 */
				border-radius: 4px;
				overflow: hidden;
				position: relative;

				.notStart {
					height: 24px;
					width: 62px;
					color: #fff;
					position: absolute;
					left: 0px;
					top: 10px;
					// background-image: url(../image/zzsh/notstart.png);
					background-image: url(../../assets/xiangning/zzsh/notstart.png);
					font-family: 思源黑体;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;
					color: #FFFFFF;
					line-height: 24px;
					box-sizing: border-box;
					padding-left: 7px;
				}

				.haveFilsh {
					height: 24px;
					width: 62px;
					color: #fff;
					position: absolute;
					left: 0px;
					top: 10px;
					background-image: url(../../assets/xiangning/zzsh/haveFinlsh.png);
					font-family: 思源黑体;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;
					color: #FFFFFF;
					line-height: 24px;
					box-sizing: border-box;
					padding-left: 7px;
				}

				.dataList_item_top_img {
					height: 126px;
					width: 224px;
					/* 修改圆角 */
					border-radius: 4px 4px 0 0;
					overflow: hidden;
				}

				.dataList_item_bottom {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					width: 100%;
					height: 82px;
					border: 1px solid #ECEEF4;
					padding: 5px 10px;
					/* 修改圆角 */
					border-radius: 0 0 4px 4px;
					overflow: hidden;
				}

				.dataList_item_bottom_top_title {
					width: 100%;
					height: 20px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					font-family: PingFangSC-Medium;
					font-size: 14px;
					font-weight: 800;
					line-height: 20px;
					color: #000000;
				}

				.dataList_item_bottom_center {
					width: 100%;
					height: 17px;
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					text-align: right;
					letter-spacing: 0em;
					color: #999999;
					display: flex;
					justify-content: space-between;


				}

				.dataList_item_bottom_address {

					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;
					color: #999999;
					width: 100%;
					height: 17px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;

				}

				.dataList_item_bottom_center span:nth-child(1) {
					max-width: 83px;
					overflow: hidden;
					white-space: nowrap;

				}



				.dataList_item_bottom_top_title:hover {
					color: #C9010A;
				}

				.dataList_item_bottom_botom {
					height: 16px;
					width: 100%;
					display: flex;
				}

				.dataList_item_bottom_botom_item {
					overflow: hidden;
					height: 100%;
					width: 74px;
					display: flex;
					justify-content: center;
				}

				.dataList_item_bottom_botom_item:nth-child(2) {
					border-left: 1px solid #ECEEF4;
					border-right: 1px solid #ECEEF4;
					;
				}

				.dataList_item_bottom_botom_item:nth-child(1) {
					display: flex;
					justify-content: start;
				}

				.dataList_item_bottom_botom_item:nth-child(3) {
					display: flex;
					justify-content: end;
				}

				.dataList_item_bottom_botom_item_icon {
					height: 12px;
					width: 12px;
					margin-right: 2px;
					position: relative;
				}

				.dataList_item_bottom_botom_item_icon img {
					position: absolute;
					top: 2.5px;
				}

				.dataList_item_bottom_botom_item:nth-child(3) .dataList_item_bottom_botom_item_icon {
					height: 10px;
					width: 15px;
				}

				.dataList_item_bottom_botom_item_icon img {
					height: 100%;
					width: 100%;
				}

				.dataList_item_bottom_botom_item_content {
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;

					color: #999999;
				}

			}

			.dataList_item_active:nth-child(4n) {
				margin-right: 0;
			}

			// 专题培训
			.dataList_item_ztpx {
				width: 224px;
				height: 186px;
				box-sizing: border-box;
				margin-bottom: 20px;
				margin-right: 20px;
				position: relative;

				.notStart {
					height: 24px;
					width: 62px;
					color: #fff;
					position: absolute;
					left: 0px;
					top: 10px;
					// background-image: url(../image/zzsh/notstart.png);
					background-image: url(../../assets/xiangning/zzsh/notstart.png);
					font-family: 思源黑体;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;
					color: #FFFFFF;
					line-height: 24px;
					box-sizing: border-box;
					padding-left: 7px;
				}

				.haveFilsh {
					height: 24px;
					width: 62px;
					color: #fff;
					position: absolute;
					left: 0px;
					top: 10px;
					background-image: url(../../assets/xiangning/zzsh/haveFinlsh.png);
					font-family: 思源黑体;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;
					color: #FFFFFF;
					line-height: 24px;
					box-sizing: border-box;
					padding-left: 7px;
				}

				.dataList_item_top_img {
					height: 126px;
					width: 224px;
				}

				.dataList_item_bottom {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					width: 100%;
					height: 64px;
					border: 1px solid #ECEEF4;
					padding: 10px;

					.dataList_item_bottom_top_title {
						width: 100%;
						height: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						font-family: PingFangSC-Medium;
						font-size: 14px;
						font-weight: 800;
						line-height: 20px;
						color: #000000;
					}

					.dataList_item_bottom_top_title:hover {
						color: #C9010A;
					}

					.dataList_item_bottom_botom {
						height: 16px;
						width: 100%;
						display: flex;

						.dataList_item_bottom_botom_item {
							overflow: hidden;
							height: 100%;
							width: 74px;
							display: flex;
							justify-content: center;

							.dataList_item_bottom_botom_item_icon {
								height: 12px;
								width: 12px;
								margin-right: 2px;
								position: relative;

								img {
									position: absolute;
									top: 2.5px;
									height: 100%;
									width: 100%;
								}
							}

							.dataList_item_bottom_botom_item_content {
								font-family: PingFangSC-Regular;
								font-size: 12px;
								font-weight: normal;
								letter-spacing: 0em;

								color: #999999;
							}
						}

						.dataList_item_bottom_botom_item:nth-child(2) {
							border-left: 1px solid #ECEEF4;
							border-right: 1px solid #ECEEF4;
							;
						}

						.dataList_item_bottom_botom_item:nth-child(1) {
							display: flex;
							justify-content: start;
						}

						.dataList_item_bottom_botom_item:nth-child(3) {
							display: flex;
							justify-content: end;

							.dataList_item_bottom_botom_item_icon {
								height: 10px;
								width: 15px;
							}
						}
					}
				}


			}

			.dataList_item_ztpx:nth-child(4n) {
				margin-right: 0;

			}

			.uerInfo {
				width: 100%;
				height: 100%;
				// background-color: pink;
			}

			.myWork {
				width: 100%;
				height: 100%;
				font-family: PingFangSC-Regular;
				font-size: 14px;
				font-weight: normal;
				letter-spacing: 0em;

				color: #000000;

				.myWork_center {
					display: flex;
					justify-content: space-between;
					margin-top: 20px;
				}

				.myWork_content {
					margin-top: 20px;
					width: 100%;
					display: flex;
					justify-content: space-between;

					.myWork_content_right {
						width: 886px;

						p {
							text-indent: 24px;

							img {
								display: block;
								width: 400px;
								height: 300px;
								margin: 0 auto;
							}
						}
					}
				}

				.myWork_attachment {
					width: 100%;
					display: flex;
					justify-content: start;
					margin-top: 15px;

					.myWork_attachment_left {
						margin-top: 5px;
					}

					.myWork_attachment_right_item {
						margin-top: 5px;
						display: flex;
						align-items: center;
						cursor: pointer;
					}
				}

				.myWork_bottom {
					margin-top: 20px;
					width: 500px;
					display: flex;
					justify-content: center;
				}
			}
		}
	}
}
</style>
